import { Row, Col, Badge } from 'react-bootstrap';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';

const TransactionTypeSelector = ({ transactionTypes, selectedType, onSelect, error }) => {
  return (
    <div className="step-content">
      <div className="mb-4">
        <h4 className="fw-bold text-primary mb-2">Type de Transaction</h4>
        <p className="text-muted mb-4">
          Sélectionnez le type d'opération que vous souhaitez effectuer. 
          Chaque type a des règles et exigences spécifiques.
        </p>
      </div>

      {error && (
        <div className="alert alert-danger border-0 shadow-sm mb-4" role="alert">
          <FaInfoCircle className="me-2" />
          {error}
        </div>
      )}

      <Row className="g-4">
        {transactionTypes.map((type) => (
          <Col md={6} lg={4} key={type.value}>
            <TransactionTypeCard 
              type={type}
              isSelected={selectedType === type.value}
              onSelect={() => onSelect(type.value)}
            />
          </Col>
        ))}
      </Row>

      {/* Légende */}
      <div className="mt-5 pt-4 border-top">
        <div className="row">
          <div className="col-md-6">
            <h6 className="fw-semibold mb-3">Indicateurs :</h6>
            <div className="d-flex flex-wrap gap-3">
              <div className="d-flex align-items-center">
                <span className="legend-dot bg-primary"></span>
                <small className="ms-2 text-muted">Compte source requis</small>
              </div>
              <div className="d-flex align-items-center">
                <span className="legend-dot bg-success"></span>
                <small className="ms-2 text-muted">Compte destination requis</small>
              </div>
              <div className="d-flex align-items-center">
                <span className="legend-dot bg-warning"></span>
                <small className="ms-2 text-muted">Documents obligatoires</small>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="alert alert-info border-0 bg-light mt-3 mt-md-0">
              <FaInfoCircle className="me-2" />
              <small>
                <strong>Astuce :</strong> Survolez chaque type pour voir plus de détails. 
                Cliquez pour sélectionner.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TransactionTypeCard = ({ type, isSelected, onSelect }) => {
  const Icon = type.icon;
  
  return (
    <div 
      className={`transaction-type-card ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
      data-tooltip={type.guide || type.description}
    >
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className={`card-icon bg-${type.color}-subtle`}>
              <Icon className={`text-${type.color}`} size={20} />
            </div>
            <h6 className="mb-0 ms-3 fw-bold">{type.label}</h6>
          </div>
          
          {isSelected && (
            <div className="selected-badge">
              <FaCheck size={14} />
            </div>
          )}
        </div>
      </div>
      
      <div className="card-body">
        <p className="card-description text-muted">{type.description}</p>
        
        <div className="requirements mt-3">
          <div className="d-flex flex-wrap gap-2">
            {type.requires.fromAccount && (
              <Badge bg="bg-primary bg-opacity-10 border border-primary border-opacity-25 text-primary" className="requirement-badge">
                Compte source
              </Badge>
            )}
            {type.requires.toAccount && (
              <Badge bg="success bg-opacity-10 border border-success border-opacity-25 text-success" className="requirement-badge">
                Compte destination
              </Badge>
            )}
            {type.requires.conversion && (
              <Badge bg="info bg-opacity-10 border border-info border-opacity-25 text-info" className="requirement-badge">
                Conversion
              </Badge>
            )}
            {type.requires.documents && (
              <Badge bg="warning bg-opacity-10 border border-warning border-opacity-25 text-warning" className="requirement-badge">
                Documents
              </Badge>
            )}
          </div>
        </div>
        
        {type.workflow && (
          <div className="workflow-info mt-3">
            <small className="text-muted d-block">
              <strong>Workflow :</strong> {type.workflow}
            </small>
          </div>
        )}
      </div>
      
      <div className="card-footer">
        <small className="text-muted">
          Cliquez pour sélectionner
        </small>
      </div>
    </div>
  );
};

export default TransactionTypeSelector;